export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4767.85bc68b3.jpg";